module.exports = {"350603001":"步文街道","350603002":"碧湖街道","350603003":"蓝田街道","350603004":"朝阳街道","350603005":"景山街道","350603103":"郭坑镇","350603500":"蓝田开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350603.json
// module id = 1320
// module chunks = 0